import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "../context/ThemeContext";
import { getAdvancePayments } from "../hooks/advancePaymentsApi";
import { useEffect } from "react";

const OrderItemsModal = ({ open, onClose, order }) => {
  const { darkMode } = useTheme();
  const [advancePayments, setAdvancePayments] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (open && order?.id) {
      getAdvancePayments(order.id, token)
        .then((data) => setAdvancePayments(data.payments || []))
        .catch((err) => console.error("Eroare la preluarea plăților:", err));
    }
  }, [open, order]);
  if (!order) return null;

  const format = (val, fixed = 2) => {
    if (val === null || val === undefined || val === "") return "0";
    if (typeof val === "string") val = parseFloat(val);
    if (isNaN(val)) return "0";
    const fixedVal = Number(val).toFixed(fixed);
    return fixedVal.endsWith(".00") ? parseInt(val).toString() : fixedVal;
  };

  const totalMP = order.items.reduce((sum, i) => sum + (parseFloat(i.quantityMP) || 0), 0);
  const totalML = order.items.reduce((sum, i) => sum + (parseFloat(i.quantityML) || 0), 0);
  const totalBUC = order.items.reduce((sum, i) => sum + (parseInt(i.quantityBUC) || 0), 0);


  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: darkMode ? "#1e293b" : "#ffffff",
          color: darkMode ? "#e0e0e0" : "#000000",
          boxShadow: 24,
          p: 4,
          maxWidth: 1200,
          width: "95%",
          borderRadius: 3,
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            color: darkMode ? "#94a3b8" : "#555",
            transition: "color 0.2s",
            "&:hover": {
              color: darkMode ? "#f87171" : "#dc2626",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <h2 className="text-2xl font-bold mb-6 text-center">
          Produse din comanda #{order.orderNumber}
        </h2>

        <div className="overflow-x-auto rounded">
          <table
            className={`w-full border text-sm rounded ${darkMode ? "border-gray-700" : "border-gray-300"
              }`}
          >
            <thead>
              <tr
                className={`text-center text-xs uppercase tracking-wide ${darkMode
                  ? "bg-gray-800 text-gray-100"
                  : "bg-gray-200 text-gray-900"
                  }`}
              >
                <th className="border px-4 py-2 min-w-[50px] whitespace-nowrap">
                  #
                </th>
                <th className="border px-4 py-2 min-w-[120px] whitespace-nowrap">
                  Material
                </th>
                <th className="border px-4 py-2 min-w-[80px] whitespace-nowrap">
                  Lungime
                </th>
                <th className="border px-4 py-2 min-w-[80px] whitespace-nowrap">
                  Lățime
                </th>
                <th className="border px-4 py-2 min-w-[80px] whitespace-nowrap">
                  Bucăți
                </th>
                <th className="border px-4 py-2 min-w-[80px] whitespace-nowrap">
                  MP
                </th>
                <th className="border px-4 py-2 min-w-[80px] whitespace-nowrap">
                  ML
                </th>
                <th className="border px-4 py-2 min-w-[80px] whitespace-nowrap">
                  BUC
                </th>
                <th className="border px-4 py-2 min-w-[100px] whitespace-nowrap">
                  Bizot
                </th>
              </tr>
            </thead>
            <tbody>
              {order.items.map((item, idx) => (
                <tr
                  key={idx}
                  className={`text-center transition ${darkMode
                    ? idx % 2 === 0
                      ? "bg-gray-800 text-gray-100 hover:bg-gray-700"
                      : "bg-gray-900 text-gray-100 hover:bg-gray-800"
                    : idx % 2 === 0
                      ? "bg-white text-black hover:bg-gray-50"
                      : "bg-gray-100 text-black hover:bg-gray-200"
                    }`}
                >
                  <td className="border px-4 py-2 whitespace-nowrap">
                    {idx + 1}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap">
                    {item.materialName}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap">
                    {format(item.length)}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap">
                    {format(item.width)}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap">
                    {format(item.quantity, 0)}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap">
                    {format(item.quantityMP)}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap">
                    {format(item.quantityML)}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap">
                    {format(item.quantityBUC, 0)}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap">
                    {item.bizot || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr
                className={`text-center font-semibold ${darkMode ? "bg-gray-900 text-gray-100" : "bg-gray-100 text-gray-900"
                  }`}
              >
                <td colSpan={5} className="border px-4 py-2 text-right">
                  Total:
                </td>
                <td className="border px-4 py-2">{format(totalMP)}</td>
                <td className="border px-4 py-2">{format(totalML)}</td>
                <td className="border px-4 py-2">{format(totalBUC, 0)}</td>
                <td className="border px-4 py-2"></td>
              </tr>
            </tfoot>
          </table>
          {/* Dacă este comandă cu avans, afișăm plățile */}
          {order.isAdvanceOrder && (
            <div className="mt-6">
              <h3 className="text-lg font-semibold mb-2">
                Plăți de avans ({advancePayments.length})
              </h3>
              {advancePayments.length > 0 ? (
                <table
                  className={`w-full border text-sm rounded ${darkMode ? "border-gray-700" : "border-gray-300"
                    }`}
                >
                  <thead>
                    <tr
                      className={`text-center text-xs uppercase tracking-wide ${darkMode ? "bg-gray-800 text-gray-100" : "bg-gray-200 text-gray-900"
                        }`}
                    >
                      <th className="border px-4 py-2">Data plății</th>
                      <th className="border px-4 py-2">Sumă (EUR)</th>
                      <th className="border px-4 py-2">Observație</th>
                    </tr>
                  </thead>
                  <tbody>
                    {advancePayments.map((p, i) => (
                      <tr
                        key={i}
                        className={`text-center ${darkMode
                            ? "bg-gray-900 hover:bg-gray-800"
                            : "bg-white hover:bg-gray-50"
                          }`}
                      >
                        <td className="border px-4 py-2">
                          {new Date(p.paymentDate).toLocaleDateString("ro-RO")}
                        </td>
                        <td className="border px-4 py-2 font-semibold text-green-500">
                          {p.amount.toLocaleString("ro-RO")} EUR
                        </td>
                        <td className="border px-4 py-2">{p.note || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="italic text-gray-500 text-center">Nicio plată de avans înregistrată.</p>
              )}
            </div>
          )}

        </div>

      </Box>
    </Modal>
  );
};

export default OrderItemsModal;
